import { Plate } from '@/components/landing/primitives';
import { stagger } from '@/components/landing/stagger';
import { Team3D } from '@/components/landing/team-3d/Team3D';
import { CITIES } from '@/content/team';

/**
 * Where the team works: four cities as a list (what crawlers and screen
 * readers get, and the words beside the globe), and the globe itself — a
 * still of it, replaced by the live 3D where it runs.
 */
export function TeamSection() {
  return (
    <Plate eyebrow="Team" id="team" labelledBy="team-title">
      <div className="grid items-center gap-12 lg:grid-cols-[5fr_7fr] lg:gap-16">
        <div>
          <h2 id="team-title" className="lp-h2 lp-reveal max-w-xl" style={stagger(1)}>
            One team across Asia.
          </h2>
          <p className="lp-body lp-reveal mt-6 max-w-md" style={stagger(2)}>
            We work from Bangkok, Tokyo, Beijing and Hong Kong, as one team.
          </p>
          <ul className="lp-reveal mt-10 grid grid-cols-2 gap-x-8 gap-y-6" style={stagger(3)} aria-label="Where we work">
            {CITIES.map((c) => (
              <li key={c.id} className="border-t border-[hsl(var(--border-strong))] pt-4">
                <span className="flex items-center gap-2.5 text-xl font-semibold tracking-tight text-foreground md:text-2xl">
                  <span aria-hidden className="h-2 w-2 shrink-0 rounded-full bg-primary" />
                  {c.city}
                </span>
                {c.country && <span className="mt-1 block pl-[1.125rem] text-[15px] text-muted-foreground">{c.country}</span>}
              </li>
            ))}
          </ul>
        </div>

        <div className="lp-reveal" style={stagger(2)}>
          <Team3D>
            <img
              loading="lazy"
              decoding="async"
              src="/img/team-globe-1200.webp"
              srcSet="/img/team-globe-800.webp 800w, /img/team-globe-1200.webp 1200w"
              sizes="(min-width: 1360px) 730px, (min-width: 1024px) 55vw, 100vw"
              width={1200}
              height={1080}
              alt="A globe turned to Asia, with Bangkok linked to Hong Kong, Beijing and Tokyo"
              className="h-full w-full object-cover"
            />
          </Team3D>
        </div>
      </div>
    </Plate>
  );
}
